"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Breadcrumbs = void 0;
const react_1 = __importDefault(require("react"));
const Breadcrumb_1 = __importDefault(require("react-bootstrap/Breadcrumb"));
require("./Breadcrumbs.scss");
const Breadcrumbs = (props) => {
    const stepItems = props.steps
        .filter((step) => step.showBreadcrumb)
        .map((step, index) => {
        return (react_1.default.createElement("li", { key: index, className: "breadcrumb-item" + (index === props.currentStep ? " active" : "") }, step.type));
        // For breadcrumbs as links (currently not in use because it's too difficult for validation).
        // return (
        //   <Breadcrumb.Item
        //     key={index}
        //     href="#"
        //     active={index === props.currentStep}
        //     onClick={() => props.onCurrentStepChange(index)}
        //   >
        //     {name}
        //   </Breadcrumb.Item>
        // );
    });
    return react_1.default.createElement(Breadcrumb_1.default, { className: props.className }, stepItems);
};
exports.Breadcrumbs = Breadcrumbs;
